export default async (to, from, next) => {
    // sem login, só a tela de entrada abre (antes a tela protegida chegava a abrir e chamar a API)
    if(to.name !== "Login" && !localStorage.getItem("user")) {
      return next({name: "Login"});
    }
    if(to.name !== null && to.name !== "Home") {
      // só o que o App.vue usa: a rota inteira é circular (instâncias de componentes) e o erro
      // aqui impedia o next() — a navegação travava
      localStorage.setItem("previous_page", JSON.stringify({name: to.name, params: to.params, query: to.query}));
    }
    next();
}